const Server_Dev = "https://talk-sphere-conferencing-app.onrender.com";

export default Server_Dev;
